import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/currencies/form'
import { api, actionCreators } from 'store/modules/currencies'

const metadata = {
  icon: 'eur',
  page: 'currencies',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
